/** Where a user is sent: a Shell route (`internal`) or a page outside the Shell, e.g. Legacy (`external`). */
export type NavigationTarget =
  | { readonly kind: 'internal'; readonly url: string }
  | { readonly kind: 'external'; readonly url: string };

export const NavigationTarget = {
  internal: (url: string): NavigationTarget => ({ kind: 'internal', url }),
  external: (url: string): NavigationTarget => ({ kind: 'external', url })
};
